export { default } from './DueDateNotice';



// WEBPACK FOOTER //
// ./app/components/borrowing/checkouts/DueDateNotice/index.js